export const navigationTriggerKey = "G"

/**
 * windows convertion
 * meta will be converted to ctrl in windows
 * Option key on Mac still registers as Alt.
 */
export const keyboardShortcut = {
  global: {
    name: "Global",
    keyboardShortcut: {
      name: "Toggle Keyboard Shortcuts",
      keys: ["meta", "/"],
    },
    secondaryNav: {
      name: "Toggle Secondary Nav",
      keys: ["meta", "\\"],
    },
    search: { name: "Global Search", keys: ["meta", "K"] },
    prompt: { name: "Global Prompt", keys: ["meta", "shift", "O"] },
    darkMode: { name: "Toggle Dark Mode", keys: ["meta", "shift", "."] },
    demoMode: { name: "Toggle Demo Mode", keys: ["meta", "shift", "D"] },
  },

  navigation: {
    name: "Navigation",
    freestyle: {
      name: "Navigate To Playground",
      keys: [navigationTriggerKey, ">", "F"],
    },
    generatedContent: {
      name: "Navigate To Content",
      keys: [navigationTriggerKey, ">", "T"],
    },
    // editor: {
    //   name: "Navigate To Editor",
    //   keys: [navigationTriggerKey, ">", "E"],
    // },
    billing: {
      name: "Navigate To Billing",
      keys: [navigationTriggerKey, ">", "B"],
    },
  },
  contentPlayground: {
    name: "Vidmaxwriter",
    generateContent: { name: "Generate Content", keys: ["meta", "Enter"] },
  },

  draftWriter: {
    name: "Draft Writer",
    saveChanges: { name: "Save Changes", keys: ["meta", "S"] },
    undo: { name: "Undo", keys: ["meta", "Z"] },
    redo: { name: "Redo", keys: ["meta", "shift", "Z"] },
    createThread: { name: "New Content", keys: ["meta", "alt", "."] },
    addSection: { name: "Add Section", keys: ["meta", "Enter"] },
    focusPreviousSection: {
      name: "Focus Previous Section",
      keys: ["shift", "Tab"],
    },
    focusNextSection: { name: "Focus Next Section", keys: ["Tab"] },
    focusMode: { name: "Toggle Focus Mode", keys: ["meta", "shift", "F"] },
  },

  ideas: {
    name: "Idea Backlog",
    saveIdea: { name: "Save Idea", keys: ["meta", "Enter"] },
  },
}
